/**
 * FilterSection Component
 * 가상계좌 검색 필터 영역
 */
import React from 'react';

interface FilterSectionProps {
    suppId: string;
    riderId: string;
    isSearchMode: boolean;
    loading: boolean;
    onSuppIdChange: (value: string) => void;
    onRiderIdChange: (value: string) => void;
    onSuppIdSearch: () => void;
    onRiderIdSearch: () => void;
    onReset: () => void;
}

const FilterSection: React.FC<FilterSectionProps> = ({
                                                         suppId,
                                                         riderId,
                                                         isSearchMode,
                                                         loading,
                                                         onSuppIdChange,
                                                         onRiderIdChange,
                                                         onSuppIdSearch,
                                                         onRiderIdSearch,
                                                         onReset,
                                                     }) => {
    return (
        <div className="card search-card">
            <div className="card-body">
                <div className="search-form virtual-account-search-form">
                    {/* 협력사 ID */}
                    <div className="form-group">
                        <div className="form-field">
                            <label className="form-label">
                                <i className="fas fa-building" />
                                협력사 ID
                            </label>
                            <input
                                type="text"
                                className="text-input"
                                value={suppId}
                                onChange={(e) => onSuppIdChange(e.target.value)}
                                placeholder="협력사 ID 입력..."
                                onKeyDown={(e) => e.key === 'Enter' && onSuppIdSearch()}
                            />
                        </div>
                    </div>

                    {/* 라이더 ID */}
                    <div className="form-group">
                        <div className="form-field">
                            <label className="form-label">
                                <i className="fas fa-motorcycle" />
                                라이더 ID
                            </label>
                            <input
                                type="text"
                                className="text-input"
                                value={riderId}
                                onChange={(e) => onRiderIdChange(e.target.value)}
                                placeholder="라이더 ID 입력..."
                                onKeyDown={(e) => e.key === 'Enter' && onRiderIdSearch()}
                            />
                        </div>
                    </div>

                    {/* 버튼 그룹 */}
                    <div className="form-group button-group">
                        {isSearchMode && (
                            <button className="btn btn-secondary" onClick={onReset}>
                                <i className="fas fa-redo" />
                                초기화
                            </button>
                        )}
                        <button
                            className="btn btn-primary"
                            onClick={onSuppIdSearch}
                            disabled={loading || !suppId.trim()}
                        >
                            <i className="fas fa-building" />
                            협력사 조회
                        </button>
                        <button
                            className="btn btn-primary"
                            onClick={onRiderIdSearch}
                            disabled={loading || !riderId.trim()}
                        >
                            <i className="fas fa-motorcycle" />
                            라이더 조회
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FilterSection;
